var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1641_45425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7837 9.20242C17.7837 8.45992 17.7275 7.91992 17.5927 7.35742H9.15491V10.6987H14.1097C14.0086 11.5312 13.4693 12.7799 12.2671 13.6237L12.2559 13.7362L14.9186 15.8062L15.0984 15.8287C16.8062 14.2537 17.7837 11.9362 17.7837 9.20242Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15485 17.9998C11.5817 17.9998 13.6153 17.2011 15.1096 15.8173L12.2783 13.6123C11.5143 14.1411 10.5031 14.5123 9.16609 14.5123C6.78419 14.5123 4.77306 12.9373 4.054 10.7773L3.95288 10.7886L1.16652 12.9373L1.13281 13.0386C2.60464 15.9748 5.63819 17.9998 9.15485 17.9998Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04282 10.7773C3.85182 10.2148 3.73947 9.61851 3.73947 8.99976C3.73947 8.38101 3.85182 7.78476 4.03159 7.22226V7.09851L1.22275 4.91602L1.13287 4.96102C0.514922 6.17601 0.166626 7.54851 0.166626 8.99976C0.166626 10.451 0.514922 11.8235 1.12163 13.0385L4.04282 10.7773Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15498 3.47625C10.8403 3.47625 11.9863 4.2075 12.6267 4.815L15.1659 2.34C13.6042 0.88875 11.5818 0 9.15498 0C5.63831 0 2.60477 2.025 1.1217 4.96125L4.03166 7.2225C4.76196 5.05125 6.77308 3.47625 9.15498 3.47625Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1641_45425"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.166626,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.b2ef9b7d6eb60fd9602ade8f35dd2c52.svg";
export { ForwardRef as ReactComponent };